import { createFileRoute } from '@tanstack/react-router';
import { HStack } from '@/components/Layout';
import { CATALOG_TYPE_STEPS } from '../-constants/steps';
import useDeviceTypeParam from '../-hooks/useDeviceType';
import { getCatalogFormStoreContext } from '../-store/catalogFormStoreContext';
import InnerNavigation from './-components/InnerNavigation';
import ManualForm from './-components/ManualForm';
import { ProgressCard } from './-components/ProgressCard';
export const Route = createFileRoute('/_staff/device-catalog/add/$deviceType/')({
  component: CatalogForm
});
function CatalogForm() {
  const {
    deviceType
  } = useDeviceTypeParam();
  const {
    context
  } = getCatalogFormStoreContext(deviceType);
  const store = context.createStore();
  const steps = CATALOG_TYPE_STEPS[deviceType];
  return <context.Provider value={store}>
      <HStack className="w-full p-6 gap-6">
        <div className="shrink-0">
          <InnerNavigation steps={steps} />
        </div>
        <ManualForm className="grow min-w-[340px]" steps={steps} />
        <div className="shrink-0">
          <ProgressCard steps={steps} />
        </div>
      </HStack>
    </context.Provider>;
}